const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3008',
  firebase: {
    apiKey: process.env.REACT_APP_FB_API_KEY || "AIzaSyCl7rks80d2IUgEtzG1esc-tvaokxu7jCw",
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN || "vicinityim.firebaseapp.com",
    databaseURL: process.env.REACT_APP_FB_DB_URL || "https://vicinityim.firebaseio.com",
    projectId: process.env.REACT_APP_FB_PROJECT_ID || "vicinityim",
    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET || "vicinityim.appspot.com",
    messagingSenderId: process.env.REACT_APP_FB_MSG_SENDER_ID || "160389348810"
  },
  fbActionCodeSettings: {
    // URL must be whitelisted in the Firebase Console.
    url: `${window.location.origin}/email_redir`,
    // This must be true.
    handleCodeInApp: true,
  },
  useFBEmailSignup: true,
  useJWT: true,
};

console.log('config', config);

export default config;
